import { templates as templates$1 } from "../locales/be.js";
import { beTemplates } from "@progressive-development/pd-page";
import { beTemplates as beTemplates$1 } from "@progressive-development/pd-dialog";
import { beTemplates as beTemplates$2 } from "@progressive-development/pd-wizard";
import { beTemplates as beTemplates$3 } from "@progressive-development/pd-content";
import { beTemplates as beTemplates$4 } from "@progressive-development/pd-forms";
import { beTemplates as beTemplates$5 } from "@progressive-development/pd-order";
//#region src/generated/locale-wrapper/be-wrapper.ts
var templates = {
	...templates$1,
	...beTemplates$1,
	...beTemplates$5,
	...beTemplates$2,
	...beTemplates,
	...beTemplates$3,
	...beTemplates$4
};
//#endregion
export { templates };
